export enum NewsMediaEnum {
    gallery = "gallery",
    video = "video",
}

export enum ShowroomGroupId {
    Europa = "Europa",
    Asia = "Asia",
    America = "America",
}

export enum IndoorOrOutdoor {
    indoor = "indoor",
    outdoor = "outdoor",
}

export enum DesktopOrMobile {
    desktop = "desktop",
    mobile = "mobile",
}

export enum OrizontalDirection {
    left_right = "left_right",
    right_left = "right_left",
}

export enum BlockEnum {
    // TESTI E IMMAGINI
    SectionOne = "SectionOne",
    SectionOneImageTextCentered = "SectionOneImageTextCentered",
    SectionOneImageTextBackgroundCentered = "SectionOneImageTextBackgroundCentered",
    SectionOneImageTextBackground = "SectionOneImageTextBackground",
    SectionOneSmallImageLeftText = "SectionOneSmallImageLeftText",
    SectionOneSmallImageRightText = "SectionOneSmallImageRightText",
    SectionOneImageLeftFiveTexts = "SectionOneImageLeftFiveTexts",
    SectionOneImageRightFiveTexts = "SectionOneImageRightFiveTexts",
    SectionTextOnLeftBackground = "SectionTextOnLeftBackground",
    SectionTextOnRightBackground = "SectionTextOnRightBackground",
    SectionThreeImagesTwoTexts = "SectionThreeImagesTwoTexts",
    SectionOneImageThreeTexts = "SectionOneImageThreeTexts",
    SectionThreeParagraphs = "SectionThreeParagraphs",
    SectionProductFooter = "SectionProductFooter",
    SectionTitleSubtitleButton = "SectionTitleSubtitleButton",
    SectionTitleButtonWithFourPaper = "SectionTitleButtonWithFourPaper",
    SectionPaperWithTitleButtonAndRightImage = "SectionPaperWithTitleButtonAndRightImage",
    SectionTitleRightTextsButtonsOnBackground = "SectionTitleRightTextsButtonsOnBackground",
    SectionTitleWithFiveImages = "SectionTitleWithFiveImages",
    SectionTopTitleWithBackground = "SectionTopTitleWithBackground",
    SectionTextsWithButtonAndRightImage = "SectionTextsWithButtonAndRightImage",
    SectionProductDescription = "SectionProductDescription",
    SectionOneImageTextFullBackground = "SectionOneImageTextFullBackground",
    SectionTwoImagesRightTextsButtons = "SectionTwoImagesRightTextsButtons",
    SectionTwoImagesLeftTextsButtons = "SectionTwoImagesLeftTextsButtons",
    SectionOneImageRightOneTexts = "SectionOneImageRightOneTexts",
    SectionOneImageLeftOneTexts = "SectionOneImageLeftOneTexts",
    // SOLO IMMAGINI
    SectionOneImageCentered = "SectionOneImageCentered",
    SectionOneImageFull = "SectionOneImageFull",
    SectionTwoImagesLeftBig = "SectionTwoImagesLeftBig",
    SectionTwoImagesRightBig = "SectionTwoImagesRightBig",
    SectionTwoImagesVertical = "SectionTwoImagesVertical",
    SectionThreeImagesVertical = "SectionThreeImagesVertical",
    SectionFourImagesVertical = "SectionFourImagesVertical",
    SectionGallery = "SectionGallery",
    SectionGalleryFull = "SectionGalleryFull",
    SectionTwo = "SectionTwo",
    SectionProductHighlight = "SectionProductHighlight",
    // SOLO TESTO
    SectionOneTitleTwoTexts = "SectionOneTitleTwoTexts",
    SectionOneTitleTexts = "SectionOneTitleTexts",
    SectionTitleSeparator = "SectionTitleSeparator",
    SectionTitleVerticalSeparator = "SectionTitleVerticalSeparator",
    SectionTitleHomePage = "SectionTitleHomePage",
    SectionSevenTexts = "SectionSevenTexts",
    SectionTitleWithRightTextsAndButton = "SectionTitleWithRightTextsAndButton",
    SectionTitleSubtitleParagraph = "SectionTitleSubtitleParagraph",
    // VIDEO
    SectionVideo = "SectionVideo",
    SectionVideoFull = "SectionVideoFull",
    SectionVideoSideLeft = "SectionVideoSideLeft",
    SectionVideoSideRight = "SectionVideoSideRight",
    SectionVideoCompany = "SectionVideoCompany",
}
